import {useEffect, useState} from "react";
import {EnglishToPersian} from "numeral-convert";
import UserSectionMenu from "../../components/UserSectionMenu";
import AddRequestForm from "./AddRequestForm";
import UserInformation from "../../components/UserInformation";
import Pagination from "../../components/Pagination";
import {MyContext} from "../../context/myContext";
import HistoryPopUp from "../../components/HistoryPopUp";
import AddUserBox from "../../components/AddUserBox";
import EditRequestForm from "./EditRequestForm";
import {useDispatch, useSelector} from "react-redux";
import {
    callApiAgain,
    getNomadHistory, selectCallApi,
    selectNomadHistoryArray, selectShowEditForm, selectShowForm, selectShowHistory, showPopUp
} from "../common-states/commonStatesSlice";
import {
    getRequests,
    selectRequestBodyArray, selectSelectedRequest,
    selectWaterType, setRequestInfo,
    setRequestStatus,
} from "./requestSlice";
import {handleShowPopUp} from "../common-states/handleShowPopUp";

const RequestsManagement = () => {
    const headArray = ['حذف', 'بررسی وضعیت', 'سوابق', 'زمان تحویل', 'تاریخ تحویل', 'زمان ثبت', 'تاریخ ثبت', 'کد پیگیری', 'منطقه عشایری', 'شهرستان', 'شماره تلفن', 'نام متقاضی', 'وضعیت', 'ردیف',];
    const requestHistoryTableHead = ['هزینه', 'حجم آب', 'زمان تحویل', 'تاریخ تحویل', 'راننده', 'زمان درخواست', 'منطقه', 'کد پیگیری', 'نوع آب', 'ردیف',];
    const initialState = {population: '', code: '', name: '', waterVolume: '', driverId: '', insuredLiveStock: '', deliverTime: '', deliverDate: '',
        waterType: '', allocatedAt: '',allocatedByUser: '', cost: '', description: '', nomadReceiveDate: ''}
    const [editFormInputs, setEditFormInputs] = useState(initialState)
    const [nomad, setNomad] = useState({id: null, name: ''})
    const dispatch = useDispatch()
    const historyArray = useSelector(selectNomadHistoryArray)
    const bodyArray = useSelector(selectRequestBodyArray)
    const waterType = useSelector(selectWaterType)
    const selectedRequest = useSelector(selectSelectedRequest)
    const showForm = useSelector(selectShowForm)
    const showEditForm = useSelector(selectShowEditForm)
    const showHistory = useSelector(selectShowHistory)
    const callApi = useSelector(selectCallApi)

    const handleShowForm = (item) => {
        dispatch(showPopUp({type: 'showEditForm', value: !showEditForm}))
        if(showEditForm === false){ //Below setting data when showing edit form
            let scheduled_to_deliver_at = item.scheduled_to_deliver_at ? new Date(item.scheduled_to_deliver_at).toLocaleDateString('fa-IR') : '';
            let driver_allocated_at_date = item.driver_allocated_at ? new Date(item.driver_allocated_at).toLocaleDateString('fa-IR') + ' - ' : '';
            let driver_allocated_at_time = item.driver_allocated_at ? EnglishToPersian(item.driver_allocated_at.slice(11)) : '';
            let nomad_confirmed_at_date = item.nomad_confirmed_at ? new Date(item.nomad_confirmed_at).toLocaleDateString('fa-IR') + ' - ' : '';
            let nomad_confirmed_at_time = item.nomad_confirmed_at ? EnglishToPersian(item.nomad_confirmed_at.slice(11)) : '';
                setEditFormInputs({population: item.nomad.population, code: item.tanker_request_id, name: item.nomad.name,
                waterVolume: item.water_volume, driverId: (item.driver?.driver_id ?? ''), insuredLiveStock: item.nomad.insured_livestock_count,
                deliverTime: (item.scheduled_time ?? ''), deliverDate: scheduled_to_deliver_at, waterType: (item.water_type === 1 ? 'آب شرب' : 'آب دام'),
                allocatedAt: (driver_allocated_at_date + driver_allocated_at_time), allocatedByUser: item.driver_allocated_at_user_id.name, cost: item.cost,
                description: (item.description ?? ''), nomadReceiveDate: (nomad_confirmed_at_date + nomad_confirmed_at_time)
            })
            dispatch(setRequestStatus({isRejected: item.is_rejected}))
        }
    }
    const handleShowHistory = (item) => {
        dispatch(showPopUp({type: 'showHistory', value: !showHistory}))
        setNomad({...nomad, name: item?.nomad?.name})
        if(showHistory === false){
            dispatch(getNomadHistory(item.nomad_id))
        }
    }
    const handleClosePopup = () => {
        handleShowPopUp(dispatch, showForm, showEditForm, showHistory)
    }

    const handleChangePage = (item) => {
        dispatch(getRequests({searchParam: '', waterType, pageNum: item, dispatch}))
    }

    const handleSearch = (searchParam) => {
        dispatch(getRequests({searchParam, waterType, pageNum: 1, dispatch}))
    }

    useEffect(() => {
        dispatch(getRequests({searchParam: '', waterType, pageNum: 1, dispatch}))
        dispatch(callApiAgain(false))
        return () => dispatch(setRequestStatus({styles: []}))
        // eslint-disable-next-line
    }, [callApi])

    useEffect(() => {
        if(selectedRequest.obj !== null){
            if(selectedRequest.type === 'showEditForm'){
                handleShowForm(selectedRequest.obj)
            }
            else if(selectedRequest.type === 'showHistory'){
                handleShowHistory(selectedRequest.obj)
            }
            dispatch(setRequestInfo({obj: null, type: ''}))
        }
        // eslint-disable-next-line
    }, [selectedRequest])

    return(
        <div className='request-box'>
            <div className={`${(showHistory || showEditForm || showForm) && 'show-dark-background'} dark-background`} onClick={handleClosePopup}></div>
            <MyContext.Provider value={{showHistory, handleShowHistory, headArray: requestHistoryTableHead, bodyArray: historyArray, title: `سوابق درخواست های ${nomad.name}`}}>
                <HistoryPopUp />
            </MyContext.Provider>
            <MyContext.Provider value={{formTitle: 'مشاهده و بررسی درخواست', showEditForm, handleShowForm, editFormInputs}}>
                <AddUserBox formComponent={EditRequestForm} />
            </MyContext.Provider>
            <UserSectionMenu buttonText='افزودن درخواست' formTitle='افزودن درخواست جدید' formComponent={AddRequestForm} getSearchedInfo={handleSearch} />
            <MyContext.Provider value={{headArray, bodyArray, title: 'درخواست های ثبت شده'}}>
                <UserInformation />
            </MyContext.Provider>
            <Pagination handleChangePage={handleChangePage} />
        </div>
    )
}

export default RequestsManagement